module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00027"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS.")]), _vm._v(" "), _c('table', {
    staticClass: "contents",
    attrs: {
      "summary": "List of illustrations"
    }
  }, [_c('tbody', {
    staticClass: "calibre11"
  }, [_c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdpg1"
  }, [_vm._v("PAGE")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("TWILIGHT AT MIDDAY—FEBRUARY, 1874")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0002#illus1"
    }
  }, [_c('i', {
    staticClass: "calibre10"
  }, [_vm._v("Frontispiece")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE FIRST ICE")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0013#illus2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("STILL LIFE IN THE FROZEN OCEAN")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0015#illus3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("GWOSDAREW INLET")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0015#illus4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("FORMATION OF THE DEPÔT AT “THE THREE COFFINS”")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0015#illus5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE “TEGETTHOFF” AND “ISBJÖRN” SEPARATE")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0015#illus6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE “TEGETTHOFF” FINALLY BESET")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0015#illus7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("ATTEMPTS TO GET FREE IN SEPTEMBER")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0016#illus8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("SEAL-HUNTING—SEPTEMBER 1872")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0016#illus9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("SHOOTING AT A TARGET, OCTOBER 1872")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0016#illus10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("PARHELIA ON THE COAST OF NOVAYA ZEMLYA")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0016#illus11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("AN OCTOBER NIGHT IN THE ICE")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0017#illus12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE MOON WITH ITS HALO")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0017#illus13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("OUR COAL-HOUSE ON THE FLOE")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0017#illus14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE TWILIGHT IN NOVEMBER 1872")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0018#illus15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("SUMBU CHASED FOR A FOX")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0018#illus16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("WANDERINGS ON THE ICE IN OUR FIRST WINTER")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0018#illus17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("ENCOUNTER WITH A POLAR BEAR")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0018#illus18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("ICE-HOLE COVERED WITH YOUNG ICE")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0018#illus19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CARLSEN MAKES THE ENTRY IN THE LOG")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0018#illus20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE “TEGETTHOFF” IN THE FULL MOON")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0019#illus21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("DIVINE SERVICE ON DECK")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0019#illus22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("ICE-PRESSURE IN THE POLAR NIGHT")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0020#illus23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("FRUITLESS ATTEMPT TO RESCUE MATOSCHKIN")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0021#illus24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("SUNRISE (1873)")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0022#illus25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE CARNIVAL ON THE ICE")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0022#illus26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE “TEGETTHOFF” DRIFTING IN PACK-ICE—MARCH 1873")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0022#illus27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("SOUNDING IN THE FROZEN OCEAN")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0023#illus28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("APPROACHING THE LAND BY MOONLIGHT")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0025#illus29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("DEPARTURE OF THE SUN IN THE SECOND WINTER")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0026#illus30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("NOON ON DECEMBER 21, 1873")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0026#illus31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("PEKEL, SUMBU, AND JUBINAL")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0026#illus32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("IN THE MESS-ROOM")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0026#illus33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE AURORA DURING THE ICE-PRESSURE")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0028#illus34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("KRISCH, THE ENGINEER")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0029#illus35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("TEAM OF SEVEN MEN AND THREE DOGS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0031#illus36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE COOKING APPARATUS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0031#illus37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE SLEDGE WITH ITS LOAD")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0031#illus38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE DRESS OF THE ARCTIC SLEDGER")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0031#illus39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("TOROSSY IN HARNESS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0031#illus40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CAPE TEGETTHOFF")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0032#illus41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("242")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("MELTING SNOW DURING A HALT NEAR CAPE BERGHAUS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0032#illus42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("244")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00028",
      "title": "[xxiv]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_xxiv",
      "title": "[xxiv]"
    }
  })]), _vm._v("ON THE SONKLAR-GLACIER")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0033#illus43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("247")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("BLOCK OF SNOW")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0033#illus44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("254")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE BURIAL OF KRISCH")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0033#illus45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("256")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("LIPARIS GELATINOSUS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0034#illus46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("266")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("HIPPOLYTE PAYERI")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0034#illus47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("268")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("HYALONEMA LONGISSIMUM")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0034#illus48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("268")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("UMBELLULA")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0034#illus49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("269")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("KORETHRASTES HISPIDUS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0034#illus50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("270")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("NEPHTHYS LONGISETOSA")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0034#illus51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("270")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE DOGS DIFFER AS TO THE TREATMENT OF YOUNG BEARS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#illus52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("273")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE WINTER HOLE OF A BEAR")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#illus53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("277")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("LIFE IN THE TENT")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#illus54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("279")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CAPE FRANKFURT, AUSTRIA SOUND, AND THE WÜLLERSDORF MOUNTAINS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#illus55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("280")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("HOW SUMBU WAS LOST")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#illus56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("284")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CAPE EASTER AND STERNEK SOUND")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#illus57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("285")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("HOW WE RECEIVED BEARS. CAPE TYROL IN THE BACKGROUND")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#illus58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("286")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("DINING ON BEARS’ FLESH")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#illus59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("287")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CUTTING UP THE BEARS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0035#illus60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("292")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("ICEBERGS AT THE BASE OF THE MIDDENDORF GLACIER")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#illus61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("298")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE SLEDGE FALLS INTO A CREVASSE ON THE MIDDENDORF GLACIER")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#illus62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("300")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("KLOTZ’S AMAZEMENT")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#illus63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("302")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE ALARM OF THE HOHENLOHE PARTY")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#illus64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("303")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("HALT UNDER CROWN-PRINCE RUDOLF’S LAND")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#illus65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("305")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CAPE AUK")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#illus66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("307")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CAPE SÄULEN")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#illus67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("309")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE AUSTRIAN FLAG PLANTED AT CAPE FLIGELY")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0036#illus68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("311")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("MELTING SNOW ON CAPE GERMANIA")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("315")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("ENCAMPING ON ONE OF THE COBURG ISLANDS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("318")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE VIEW FROM CAPE TYROL. COLLINSON FIORD—WIENER NEUSTADT ISLAND")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("321")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("BREAKING IN")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("323")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("ARRIVAL BEFORE THE OPEN SEA")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("325")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("DRAGGING THE SLEDGE UNDER THE GLACIERS OF WILCZEK LAND")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("326")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE SLEDGE IN A SNOW-STORM")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("328")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("DIGGING OUT THE DEPÔT")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("329")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE MIDNIGHT SUN BETWEEN CAPE BERGHAUS AND KOLDEWEY ISLAND")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("331")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE “TEGETTHOFF” DESCRIED")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("332")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("KLOTZ")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0037#illus79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("333")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("MARKHAM SOUND, RICHTHOFEN PEAK FROM CAPE BRÜNN")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0038#illus80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("338")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("FIRST ABANDONMENT OF THE “TEGETTHOFF”")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("348")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("IN THE HARBOUR OF AULIS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("352")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("WE LAUNCH AT LAST")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("355")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("MARCHING THROUGH ICE-HUMMOCKS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("357")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("HALT AT NOON")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("358")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CROSSING A FISSURE")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("359")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CARLSEN")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("361")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("SCENE ON THE ICE")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("366")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("BEARS IN THE WATER")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("371")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("CALKING THE BOATS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("374")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("FAREWELL TO THE FROZEN OCEAN")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0040#illus91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("375")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("LANDING ON THE COAST OF NOVAYA ZEMLYA")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0041#illus92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("380")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_vm._v("THE BAY OF DUNES. THE RUSSIAN SCHOONERS")]), _vm._v(" "), _c('td', {
    staticClass: "tdpg"
  }, [_c('span', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0041#illus93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("385")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0